export const PRESIDENT_ADDRESS_PAGE =
  "ucapan-president-tharman-parlimen-ke-15-sg";
export const PRESIDENT_ADDRESS_TAGS = "15thparliament";
